const initialState = {
  isNewSearch: false,
  originalSearchType: '',
};

const isNewSearch = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_NEW_SEARCH':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default isNewSearch;
